import api from "@mixins/api.js";
import {env} from "@mixins/environment.js"
import _utente from "@mixins/utente.js";
import _storage from "@mixins/storage.js"

const getAuthToken =  _storage.getAuthToken;
const setAuthToken =  _storage.setAuthToken;

/**
 * Effettua il login usando l'auth_token salvato in localStorage.
 * @return Object utente
 */
const authTokenLogin = async function () {
    const url = env.api_base_url+'/api/v2/utente.php?token_login=1';
    const result = await api(url, 'POST');
    if (result.data) {
        return result.data;
    } else {
        return false;
    }
}

/**
 * Effettua il login usando l'auth_token salvato in localStorage.
 * @return String auth_token
 */
const login = async function (auth) {
    const url = env.api_base_url+'/api/v2/utente.php?authorize=1';
    const token = `${auth.username}:${auth.password}`;
    const encodedToken = Buffer.from(token).toString('base64');
    const headers = { 'Authorization': 'Basic '+ encodedToken };
    const result = await api(url, 'PUT', null, headers);
    // Se il login fallisce data non è il token (true, 'NONATTIVO'): conta solo success.
    if (result.success && typeof result.data === 'string') {
        setAuthToken(result.data);
        const auth_token = result.data;    
        return auth_token;
    } else {
        return false;
    }
}


const logout = async function () {
    const url = env.api_base_url+'/api/v2/utente.php?logout';
    await api(url, 'DELETE');
    return true;
}

const state = () => ({
    options: {},
    utente: null,
    auth_token: null,
    // abbinamenti allenatore-atleta dell'atleta in sessione (tutti gli stati)
    abbinamenti: [],
});

// getters
const getters = {
    utente: (state) => (state.utente),
    options: (state) => (state.options),
};

// actions: (dispatch) sono il Controller 
const actions = {
    // ritorna true se l'elenco è stato aggiornato
    loadAbbinamenti: async function ({commit}) {
        const result = await api(`${process.env.VUE_APP_API_BASE_URL}/api/v2/allenatore_atleta.php?abbinamenti`, 'GET');
        if (!result || !result.success) return false;
        commit('setAbbinamenti', result.data || []);
        return true;
    },

    getOption: async function ({state}, key) {
        if (!(key in state.options)) {
        const value = await _utente.getOption(key);
            state.options[key] = value;
        }
        return state.options[key];
    },

    setOption: function ({commit}, { key, value }) {
        commit('setOption',{key:key, value:value});
    },


    setUtente: function ({commit}, utente) {
        commit('setUtente', utente);
    },

    login: async function ({commit,dispatch}, auth = null) {
        let auth_token;
        if (auth) {
            auth_token = await login(auth);
            if (!auth_token) {
                await dispatch('logout');
                return false;
            }
        } else {
            auth_token = getAuthToken();
        }
        commit('setAuthToken', auth_token);

        const utente = await authTokenLogin();
        if (utente) {
            commit('setUtente', utente);
            if (utente.is_atleta) {
                dispatch('atleti/loadAtleta', utente.utente_id, {root:true});
            } else {
                let atleta_id = _storage.get('atletaId');
                if (atleta_id) {
                    dispatch('atleti/loadAtleta', atleta_id, {root:true});
                }
            }
            return utente;
        } else {

            await dispatch('logout');
            return false;
        }

    },

    logout: async function ({commit}) {
        await logout();
        _storage.deleteAuthToken();
        commit('setAuthToken', null);
        commit('setUtente',null);
        return true;

    },

};

// mutations: (commit) cambiano lo state (Model)
const mutations = {

    setAbbinamenti (state, abbinamenti) {
        state.abbinamenti = abbinamenti;
    },

    setUtente (state, utente) {
        state.utente = utente;
    },
    setAuthToken: function (state, auth_token) {
        state.auth_token = auth_token;
    },
    setOption: async function (state, {key, value}) {
        state.options[key] = value;
        _utente.setOption(key, value);
    },

}

  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
  };
